export const setLoanInfo = loanInfo => {
  localStorage.setItem('loanInfo', JSON.stringify(loanInfo));
  return true;
};

export const getLoanInfo = () => {
  return localStorage.hasOwnProperty('loanInfo')
    ? JSON.parse(localStorage.getItem('loanInfo'))
    : false;
};

export const removeLoanInfo = () => {
  return localStorage.hasOwnProperty('loanInfo')
    ? localStorage.removeItem('loanInfo')
    : false;
};
